import Model, { attr } from '@ember-data/model';

export default class RoomControlIrCodeSetModel extends Model {
  @attr
  declare label: string;

  @attr
  declare deviceType: string;
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'room-control/ir-code-set': RoomControlIrCodeSetModel;
  }
}
